import { splitEmojiPrefix } from "app/pages/sales-intelligence/domain/teams/utils/splitEmojiPrefix";

import type { TeamListItem } from "app/pages/sales-intelligence/domain/teams/types/team-list-item";

const toAvatarDisplayName = (teamName: string | null): string | null => {
    const label = teamName ?? "";
    const { rest } = splitEmojiPrefix(label);
    const displayName = rest.trim() || label.trim();

    return displayName.length > 0 ? displayName : null;
};

export const getTeamAvatarInitial = (displayName: string): string => {
    const firstWord = displayName.trim().split(/\s+/)[0] ?? "";

    return [...firstWord][0]?.toLocaleUpperCase() ?? "";
};

/**
 * Names of the teams a rule is scoped to, in the order the rule lists them. An account-scoped rule
 * has no teams, so it resolves to no names here.
 */
export const resolveScoringRuleTeamNames = (
    teamIds: readonly number[] | undefined,
    allTeams: readonly TeamListItem[],
): string[] => {
    const teamsToShow = (teamIds ?? [])
        .map((id) => allTeams.find((team) => team.teamId === id))
        .filter((team): team is TeamListItem => team !== undefined);

    return teamsToShow.map((team) => toAvatarDisplayName(team.name)).filter((name): name is string => name !== null);
};
